import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppIcons } from 'app/modules/shared/app.icons';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { CalendarModule } from 'primeng/calendar';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import * as dayjs from 'dayjs';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/timezone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-hour-minute',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CalendarModule, TranslateModule],
  templateUrl: './hour-minute.component.html',
  styleUrl: './hour-minute.component.scss'
})
export class HourMinuteComponent implements OnInit, OnChanges {
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  miIcons = AppIcons;
  formName: FormGroup;
  placeholder: any;
  hourFormat = 24;

  constructor(private formGroupDirective: FormGroupDirective,
    private metaDataService: MetaDataService,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.setFormControlValue();
    this.placeholder = this.cs.getLabelValue(`${this.moduleName  }.fields.${  this.field.attributeCode  }.placeholder`, this.attributeLabels, null);
  }

  ngOnChanges() {
    if (this.field?.attributeCode === 'delivery_time_from' || this.field?.attributeCode === 'delivery_time_to') {
      this.setupTimeValidation();
    }
  }

  setupTimeValidation() {
    const controlName = this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field?.attributeCode;
    const currentControl = this.formName.get(controlName);

    if (currentControl) {
      currentControl.valueChanges.subscribe(() => {
        this.validateTimeRange();
      });
    }
  }

  validateTimeRange() {
    const fromControl = this.formName.get('delivery_time_from');
    const toControl = this.formName.get('delivery_time_to');

    if (fromControl?.value && toControl?.value) {
      const fromTime = dayjs(fromControl.value);
      const toTime = dayjs(toControl.value);

      const fromMinutes = fromTime.hour() * 60 + fromTime.minute();
      const toMinutes = toTime.hour() * 60 + toTime.minute();

      if (fromMinutes >= toMinutes) {
        if (this.field.attributeCode === 'delivery_time_from') {
          fromControl.setErrors({ timeRange: true });
        } else {
          toControl.setErrors({ timeRange: true });
        }
      } else {
        fromControl?.setErrors(null);
        toControl?.setErrors(null);
      }
    }
  }

  setFormControlValue() {
    const controlName = this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field?.attributeCode;
    const editValue = this.formName.controls[controlName].value;
    if (editValue) {
      if (this.field.attributeCode === 'allow_booking_start_time' || this.field.attributeCode === 'allow_booking_end_time') {
        this.formName.controls[controlName].setValue(editValue);
      } else {
        const dateValue = dayjs.isDayjs(editValue) ? editValue.toDate() : editValue;
        this.formName.controls[controlName].setValue(dateValue);
      }
    } else {
      if (this.field.attributeCode === 'allow_booking_start_time' || this.field.attributeCode === 'allow_booking_end_time' || this.field.attributeCode === 'start_time' || this.field.attributeCode === 'end_time') {
        this.formName.controls[controlName].setValue(null);
      } else {
        this.formName.controls[controlName].setValue(null);
      }
    }
  }
}
